//
// Generated class PaymentInstallmentTemplateLine
//

/// <reference path="PaymentInstallmentTemplateLine_ManagedObject.ts" />

class PaymentInstallmentTemplateLine extends PaymentInstallmentTemplateLine_ManagedObject
{

}
